import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Button, Container } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'
import { GetCollection } from '../../../../firebase/firebase'

const RecipeCard = (props) => {
    const recipe = props.recipe
    return (
        <>
            <Card className='h-100'>
                <Card.Img variant='top' src={recipe.image} style={{ height: '275px', width: 'auto' }} />
                <Card.Header>
                    {recipe.title}
                </Card.Header>
                <Card.Body>
                    <Row>
                        <h4>Ingredients</h4>
                        {recipe.ingredients && recipe.ingredients.map((ingredient, idx) => {
                            if (idx < 3) {


                                return (
                                    <>
                                        <Row>
                                            - {ingredient}
                                        </Row>
                                    </>
                                )
                            }

                            else if (idx === 3) {
                                return (
                                    <>
                                        <Row>
                                            ...
                                        </Row>
                                    </>
                                )
                            }

                        })}
                    </Row>
                    <Row>
                        <h4>Directions</h4>
                        {recipe.directions && recipe.directions.map((direction, idx) => {
                            if (idx < 3) {


                                return (
                                    <>
                                        <Row>
                                            - {direction}
                                        </Row>
                                    </>
                                )
                            }

                            else if (idx === 3) {
                                return (
                                    <>
                                        <Row>
                                            ...
                                        </Row>
                                    </>
                                )
                            }

                        })}
                    </Row>
                    {recipe.description}
                </Card.Body>
                <Card.Footer>
                    <Link to={`/recipes/view/${recipe.id}`}>
                        View
                    </Link>
                </Card.Footer>
            </Card >
        </>
    )
}

export const RecipesGrid = () => {
    const [recipes, setRecipes] = useState([])
    const [loading, setLoading] = useState(true)
    const [categories, setCategories] = useState([])
    useEffect(() => {
        if (loading) {
            GetCollection('recipes', false).then((data) => {
                setRecipes(data.docs.map(doc => doc.data()))

            })
            GetCollection("recipeCategories", false).then((data) => {
                setCategories(data.docs.map(doc => doc.data()))
            })
        }

    }, [loading])


    return (
        <Container fluid>
            <Row className='mt-5 mb-2 d-flex justify-content-center align-items-center'>
                <Col className='d-flex justify-content-center align-items-center'>
                    <h2>Recipe Categories</h2>
                </Col>
            </Row>


            <RecipeCategoriesList categories={categories} />

            <Row className='mt-5 mb-2 d-flex justify-content-center align-items-center'>
                <Col className='d-flex justify-content-center align-items-center'>
                    <h2>All Recipes</h2>
                </Col>
            </Row>
            <Row>

                {recipes && recipes.map((recipe, i) => {
                    return (
                        <Col sm={8} md={6} lg={4} xl={3} key={i}>
                            <RecipeCard recipe={recipe} />
                        </Col>
                    )
                })}
            </Row>

        </Container>
    )
}

const RecipeCategoriesList = (props) => {
    const categories = props.categories

    return (
        <>
            <Row className='d-flex justify-content-center'>
                {categories && categories.map((category, idx) => (

                    <RecipeCategoryCard category={category} key={idx} />

                ))}
            </Row>
        </>
    )
}

const RecipeCategoryCard = (props) => {
    const category = props.category
    const history = useHistory()
    return (
        <>
            <Col sm={8} md={6} lg={4} xl={3}>
                <Card className='h-100'>
                    <Card.Body>
                        <Card.Img

                            className='mx-auto d-block rounded-circle'
                            onClick={(e) => history.push(`/recipes/viewCategory/${category.id}`)}
                            variant='top'
                            src={category.image}
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', objectFit: 'cover', maxWidth: '100%', height: '275px' }} />
                        <Card.Title>
                            {category.title}
                        </Card.Title>
                        <Card.Text>
                            {category.description}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </>
    )
}